import * as React from "react";
import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {ITextProps, Text} from "@pg-design/text-module";

import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {HorizontalArticleList} from "./HorizontalArticleList";

interface IProps {
    heading: string;
    articles: IOfferArticle[];
    className?: string;
    as?: ITextProps["as"];
}

export const RelatedArticlesSection = (props: IProps) => {
    const {heading, articles, className, as = "h3"} = props;

    return (
        <div className={cx(containerStyle, className)}>
            <WideContent>
                <Text as={as} className={headingStyle} variant="headline_4">
                    {heading}
                </Text>

                <HorizontalArticleList articles={articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-background-200)",
    width: "100%",
    pb: "3.6rem",
    pt: 2,
    md: {
        pb: "5.6rem",
        pt: "3.6rem"
    }
});

const headingStyle = css({
    pb: 2,
    md: {
        pb: "3.6rem"
    }
});
import * as React from "react";
import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {ITextProps, Text} from "@pg-design/text-module";

import {IOfferArticle} from "../../offer/list/actions/fetch_offer_list_articles";
import {HorizontalArticleList} from "./HorizontalArticleList";

interface IProps {
    heading: string;
    articles: IOfferArticle[];
    className?: string;
    as?: ITextProps["as"];
}

export const RelatedArticlesSection = (props: IProps) => {
    const {heading, articles, className, as = "h3"} = props;

    return (
        <div className={cx(containerStyle, className)}>
            <WideContent>
                <Text as={as} className={headingStyle} variant="headline_4">
                    {heading}
                </Text>

                <HorizontalArticleList articles={articles} />
            </WideContent>
        </div>
    );
};

const containerStyle = css({
    backgroundColor: "var(--colors-background-200)",
    width: "100%",
    pb: "3.6rem",
    pt: 2,
    md: {
        pb: "5.6rem",
        pt: "3.6rem"
    }
});

const headingStyle = css({
    pb: 2,
    md: {
        pb: "3.6rem"
    }
});
